<template>
  <div>
    <h6
      class="text-center text-gray"
      style="font-size: 12px;"
      v-html="getCaption('caption.copyright_flight_schedule')"
    ></h6>
    <div class="columns justify-content-center align-items-end">
      <div class="column col-xs-12 col-sm-10 col-10">
        <div @click="getScheduleData()" class="d-inline mt-2 c-hand">
          <span>{{ getCaption('caption.bus_station_refresh') }}</span>
          <button class="btn btn-sm btn--color-purple rounded ml-2">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
      <div class="column col-xs-12 col-sm-10 col-10 mt-2">
        <ul class="tab tab-block">
          <li :class="[{'active': selectedTab == 'arrival'}, 'tab-item']">
            <a
              class="is-pointer size-3"
              @click="selectedTab = 'arrival'"
            >{{ getCaption("caption.arrival_button") }}</a>
          </li>
          <li :class="[{'active': selectedTab == 'departure'}, 'tab-item']">
            <a
              class="is-pointer size-3"
              @click="selectedTab = 'departure'"
            >{{ getCaption("caption.departure_button") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="isLoading > 0" class="d-flex justify-content-center" style="margin: 3em 0;">
      <div class="loader"></div>
    </div>
    <div v-if="departureData != null && arrivalData != null">
      <!-- arrival tab -->
      <div class="columns justify-content-center align-items-end" v-if="selectedTab === 'arrival'">
        <div class="column col-xs-12 col-sm-10 col-5">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-3 col-sm-12">
                <label class="form-label">{{ getCaption("caption.where_from") }}</label>
              </div>
              <div class="col-9 col-sm-12">
                <select v-model="selectedArrivalDest" class="form-select focus-purple">
                  <option disabled>{{ getCaption("caption.choose") }}</option>
                  <option
                    v-for="(destination, index) in Array.from(new Set(arrivalData.map(x => x.destination)))"
                    :key="index"
                  >{{ destination }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column col-xs-12 col-sm-10 col-5"></div>

        <div class="column col-xs-12 col-sm-10 col-10 mt-2 pt-2">
          <div v-if="arrivalData.length > 0" class="air-schedule--card">
            <div
              v-for="(arrival, i) in filterData(selectedArrivalDest, arrivalData)"
              :key="i"
              :class="{ 'air-schedule-even': i % 2 == 0, 'air-schedule-odd': i % 2 != 0 }"
            >
              <div class="columns">
                <div class="column col-xs-12 col-sm-12 col-2 col-mx-auto align-self-center pl-2">
                  <img class="air-schedule--image" v-bind:src="arrival.image">
                </div>
                <div class="column col-xs-12 col-sm-12 col-2 col-mx-auto align-self-center">
                  <div class="d-flex flex-column align-items-center m-2">
                    <span class="size-2">{{ getCaption("caption.flights") }}</span>
                    <span class="size-3">{{ arrival.flights }}</span>
                  </div>
                </div>
                <div class="column col-xs-12 col-sm-12 col-2 col-mx-auto align-self-center">
                  <div class="direction-row">
                    <h4 class="depart-name">{{ arrival.destination }}</h4>
                  </div>
                </div>

                <div class="column col-xs-12 col-sm-12 col-6 col-mx-auto">
                  <div class="d-flex flex-wrap justify-content-center">
                    <div class="d-flex flex-column align-items-center m-2">
                      <span class="size-2">{{ getCaption("caption.scheduled_time") }}</span>
                      <span class="size-3">{{ arrival.scheduled }}</span>
                    </div>
                    <div class="d-flex flex-column align-items-center m-2">
                      <span class="size-2">{{ getCaption("caption.estimated_time") }}</span>
                      <span v-if="arrival.estimated === ''" class="size-3">--:--</span>
                      <span v-else class="size-3">{{ arrival.estimated }}</span>
                    </div>
                    <div class="d-flex flex-column align-items-center m-2">
                      <span class="size-2">{{ getCaption("caption.flight_status") }}</span>
                      <span v-if="arrival.status === ''" class="size-3">-</span>
                      <span
                        v-else
                        :class="{ 'size-1': arrival.status.length > 7, 'size-3': arrival.status.length <= 7 }"
                      >{{ arrival.status }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="i+1 < filterData(selectedArrivalDest, arrivalData).length"
                class="divider w-100"
              ></div>
            </div>
          </div>
          <div v-else class="text-center mt-2 pt-2">
            <span class="chip size-3 p-2">{{ getCaption("caption.empty_result") }}</span>
          </div>
        </div>
      </div>
      <!-- departure tab -->
      <div
        class="columns justify-content-center align-items-end"
        v-if="selectedTab === 'departure'"
      >
        <div class="column col-xs-12 col-sm-10 col-5">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-3 col-sm-12">
                <label class="form-label">{{ getCaption("caption.where_to") }}</label>
              </div>
              <div class="col-9 col-sm-12">
                <select v-model="selectedDepartureDest" class="form-select focus-purple">
                  <option disabled>{{ getCaption("caption.choose") }}</option>
                  <option
                    v-for="(destination, index) in Array.from(new Set(departureData.map(x => x.destination)))"
                    :key="index"
                  >{{ destination }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column col-xs-12 col-sm-10 col-5"></div>

        <div class="column col-xs-12 col-sm-10 col-10 mt-2 pt-2">
          <div v-if="departureData.length > 0" class="air-schedule--card">
            <div
              v-for="(departure, i) in filterData(selectedDepartureDest, departureData)"
              :key="i"
              :class="{ 'air-schedule-even': i % 2 == 0, 'air-schedule-odd': i % 2 != 0 }"
            >
              <div class="columns">
                <div class="column col-xs-12 col-sm-12 col-2 col-mx-auto align-self-center pl-2">
                  <img class="air-schedule--image" v-bind:src="departure.image">
                </div>
                <div class="column col-xs-12 col-sm-12 col-2 col-mx-auto align-self-center">
                  <div class="d-flex flex-column align-items-center m-2">
                    <span class="size-2">{{ getCaption("caption.flights") }}</span>
                    <span class="size-3">{{ departure.flights }}</span>
                  </div>
                </div>
                <div class="column col-xs-12 col-sm-12 col-2 col-mx-auto align-self-center">
                  <div class="direction-row">
                    <h4 class="depart-name">{{ departure.destination }}</h4>
                  </div>
                </div>

                <div class="column col-xs-12 col-sm-12 col-6 col-mx-auto">
                  <div class="d-flex flex-wrap justify-content-center">
                    <div class="d-flex flex-column align-items-center m-2">
                      <span class="size-2">{{ getCaption("caption.scheduled_time") }}</span>
                      <span class="size-3">{{ departure.scheduled }}</span>
                    </div>
                    <div class="d-flex flex-column align-items-center m-2">
                      <span class="size-2">{{ getCaption("caption.estimated_time") }}</span>
                      <span v-if="departure.estimated === ''" class="size-3">--:--</span>
                      <span v-else class="size-3">{{ departure.estimated }}</span>
                    </div>
                    <div class="d-flex flex-column align-items-center m-2">
                      <span class="size-2">{{ getCaption("caption.flight_status") }}</span>
                      <span v-if="departure.status === ''" class="size-3">-</span>
                      <span
                        v-else
                        :class="{ 'size-1': departure.status.length > 7, 'size-3': departure.status.length <= 7 }"
                      >{{ departure.status }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="i+1 < filterData(selectedDepartureDest, departureData).length"
                class="divider w-100"
              ></div>
            </div>
          </div>
          <div v-else class="text-center mt-2 pt-2">
            <span class="chip size-3 p-2">{{ getCaption("caption.empty_result") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.divider {
  height: 2px !important;
  margin: 0;
}
.air-schedule--card {
  border: 1px solid #e7e9ed;
  border-radius: 2px;
  color: #000;
}
.air-schedule--image {
  width: 100%;
}
.air-schedule-odd {
  background-color: #ddd;
}
.air-schedule-even {
  background-color: #fff;
}

.tab .tab-item.active a,
.tab .tab-item a.active {
  border-bottom-color: #f78e21;
  color: #fff;
  background-color: #f78e21;

  -webkit-border-top-left-radius: 2px;
  -webkit-border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.tab .tab-item a:hover {
  color: #f78e21;
  border-bottom-color: #f78e21;
}
.tab .tab-item.active a:hover,
.tab .tab-item a.active:hover {
  color: #fff;
}
</style>

<script>
import ScheduleService from "@/services/ScheduleService.js";
import { transportationSchedule } from "@/constants/sidemenu.js";

export default {
  data() {
    return {
      selectedTab: "arrival",
      selectedArrivalDest: null,
      selectedDepartureDest: null,
      isLoading: 0,

      arrivalData: null,
      departureData: null
    };
  },

  mounted() {
    this.setSidemenu();
    this.getScheduleData();
  },

  methods: {
    setSidemenu() {
      this.$store.dispatch("setSidemenuData", {
        menu: transportationSchedule,
        parentType: "topmenu"
      });
    },

    getScheduleData() {
      this.isLoading = 2;
      this.arrivalData = null;
      this.departureData = null;
      ScheduleService.getAirArrivalSchedule().then(response => {
        this.isLoading -= 1;
        this.arrivalData = response.data.arrival;
        if (!this.selectedArrivalDest)
          this.selectedArrivalDest = this.getCaption("caption.choose");
      });
      ScheduleService.getAirDepartureSchedule().then(response => {
        this.isLoading -= 1;
        this.departureData = response.data.departue;
        if (!this.selectedDepartureDest)
          this.selectedDepartureDest = this.getCaption("caption.choose");
      });
    },

    filterData(value, data) {
      let filteredData = data.filter(x => x.destination == value);
      return filteredData.length > 0 ? filteredData : data;
    }
  }
};
</script>